import React, {FC} from 'react';

import s from './newsletterSubscription.scss';

type TermsAndPrivacyType = {
    openTermsOfUse: () => void;
    openPrivacyPolicy: () => void;
};

/**
 * Terms And Privacy
 */
export const TermsAndPrivacy: FC<TermsAndPrivacyType> = ({openPrivacyPolicy, openTermsOfUse}) => {
    /**
     * button handler
     * @param {React.MouseEvent<HTMLButtonElement, MouseEvent>} event
     * @param {() => void} callback
     */
    function handleClick(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        callback: () => void,
    ) {
        event.stopPropagation();
        callback();
    }

    return (
        <>
            <button
                className={s.link}
                onClick={event => handleClick(event, openTermsOfUse)}
                type="button"
            >
                <span>Terms of Use</span>
            </button>{' '}
            and{' '}
            <button
                className={s.link}
                onClick={event => handleClick(event, openPrivacyPolicy)}
                type="button"
            >
                <span>Privacy Policy</span>
            </button>
        </>
    );
};
